export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const ADD_ROWS_PER_PAGE = "ADD_ROWS_PER_PAGE";
export const COLOR_PALETTES = "COLOR_PALETTES";
export const RESET_COLOR_PALETTES = "RESET_COLOR_PALETTES";
export const SET_COMPANY_LOGO = "SET_COMPANY_LOGO"
export const SET_COMPANY_ICON = "SET_COMPANY_ICON"

// User
export const GETUSER = "GETUSER";
export const GETUSERDETAIL = "GETUSERDETAIL";
export const GET_DEPARTMENT_WISE_USER = "GET_DEPARTMENT_WISE_USER";
export const GET_USER_DATA_REQUEST = "GET_USER_DATA_REQUEST";
export const GET_USER_DETAILS_BY_EMAIL = "GET_USER_DETAILS_BY_EMAIL";
export const GET_USER_DATA_BY_EMAIL_COMPANY = "GET_USER_DATA_BY_EMAIL_COMPANY";
export const GET_COMPANY_NAMES = "GET_COMPANY_NAMES";
export const GET_USER_DEPARTMENTS = "GET_USER_DEPARTMENTS";
export const GET_COLLABORATOR_BY_TYPE = "GET_COLLABORATOR_BY_TYPE";
export const GET_COLLABORATOR_BY_COMPANY = "GET_COLLABORATOR_BY_COMPANY";
export const GET_ALL_USER_TYPES_INFO = "GET_ALL_USER_TYPES_INFO";

//Team
export const GETDEPARTMENT = "GETDEPARTMENT";
export const GETDEPARTMENTDETAIL = "GETDEPARTMENTDETAIL";
export const DEPTWITHUSERANDCOLLABORATORS = "DEPTWITHUSERANDCOLLABORATORS";

// STAKEHOLDER
export const GET_STAKEHOLDER = "GET_STAKEHOLDER";
export const SET_STAKEHOLDER_DETAILS = "SET_STAKEHOLDER_DETAILS";

// Manage Request
export const GET_NEW_REQUEST_DATA = "GET_NEW_REQUEST_DATA";
export const GET_OLD_REQUEST_DATA = "GET_OLD_REQUEST_DATA";
export const ACCEPT_TRANSFER = "ACCEPT_TRANSFER";
export const ACCEPT_EXTENSION = "ACCEPT_EXTENSION";
export const ACCEPT_BACK_TO_ADMIN = "ACCEPT_BACK_TO_ADMIN";
export const REJECT_REQUEST = "REJECT_REQUEST";

//Mange To DO
export const GETMANAGETODO = "GETMANAGETODO";
export const GETALLDEPARTMENTBYCOMPANYID = "GETALLDEPARTMENTBYCOMPANYID";
export const GETUSERSBYDEPARTMENTID = "GETUSERBYDEPARTMENTID";
export const GETVALIDATIONAPIID = "GETVALIDATIONAPIID";
export const CREATETODO = "CREATETODO";
export const GETTODODATABYID = "GETTODODATABYID";
export const UPDATE_TODO = "UPDATE_TODO";
export const GET_TODO_CONTROLS = "GET_TODO_CONTROLS";
export const GET_ACTIVITY_DATA_WITH_CUSTOMFIELD =
  "GET_ACTIVITY_DATA_WITH_CUSTOMFIELD";
export const GET_ACTIVITY_DATA_FOR_ONBOARDING =
  "GET_ACTIVITY_DATA_FOR_ONBOARDING";
export const SET_RETAIN_PROPS = "SET_RETAIN_PROPS";
export const SET_TODO_NOTIFICATION_DATA = "SET_TODO_NOTIFICATION_DATA"
export const SET_TODO_DATA_BY_TODO_ID = "SET_TODO_DATA_BY_TODO_ID"
export const GET_DEFAULT_MASTER_TODOS = "GET_DEFAULT_MASTER_TODOS"
export const SET_PARENT_TODO_ID_FOR_COPY = "SET_PARENT_TODO_ID_FOR_COPY"
export const SET_TODO_DATA_FOR_UPDATE_INVENTORY = "SET_TODO_DATA_FOR_UPDATE_INVENTORY"
export const CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY = "CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY"
export const SET_TODO_FIELD_LIST = "SET_TODO_FIELD_LIST"

// Manage Assets
export const GET_ASSETS = "GET_ASSETS";
export const GET_ASSET_DETAIL = "GET_ASSET_DETAIL";
export const GET_ACTIVITY_PERFORMANCE_ASSET_LIST =
  "GET_ACTIVITY_PERFORMANCE_ASSET_LIST";
export const GET_ISO_CODE = "GET_ISO_CODE"  

// Manage Assignement
export const ASSIGNMENT_TEAMS_LIST = "ASSIGNMENT_TEAMS_LIST";
export const ASSIGNMENT_ACTIVITY_LIST = "ASSIGNMENT_ACTIVITY_LIST";
export const GET_ACTIVITY_ASSIGNMENT = "GET_ACTIVITY_ASSIGNMENT";
export const GET_ACTIVITY_ASSIGNMENT_BY_CONFIGURATION_ID =
  "GET_ACTIVITY_ASSIGNMENT_BY_CONFIGURATION_ID";
export const GET_ACTIVITY_CONFIGURATION_BY_ID_ASSIGNMENT =
  "GET_ACTIVITY_CONFIGURATION_BY_ID_ASSIGNMENT";
export const EMBEDDED_ASSIGNMENT_TEAMS_LIST = "EMBEDDED_ASSIGNMENT_TEAMS_LIST";
export const EMBEDDED_ASSIGNMENT_ACTIVITY_LIST =
  "EMBEDDED_ASSIGNMENT_ACTIVITY_LIST";
export const EMBEDDED_GET_ACTIVITY_ASSIGNMENT =
  "EMBEDDED_GET_ACTIVITY_ASSIGNMENT";
export const EMBEDDED_GET_ACTIVITY_CONFIGURATION_BY_ID_ASSIGNMENT =
  "EMBEDDED_GET_ACTIVITY_CONFIGURATION_BY_ID_ASSIGNMENT";

export const GET_GROUP_LIST = "GET_GROUP_LIST";
export const GET_USER_LIST = "GET_USER_LIST";
export const GET_GROUP_UNREAD_MESSAGE_COUNT = "GET_GROUP_UNREAD_MESSAGE_COUNT";
export const GET_MESSAGE_LIST = "GET_MESSAGE_LIST";
export const GET_MAIN_GROUP_USER_LIST = "GET_MAIN_GROUP_USER_LIST";
export const GET_BOOKING_LIST = "GET_BOOKING_LIST";

// Manage Workflow
export const GET_CONFIGURATION_BY_COMPANY_ID =
  "GET_CONFIGURATION_BY_COMPANY_ID";
export const GET_CONFIGURATION_WITH_SETTING_DATA =
  "GET_CONFIGURATION_WITH_SETTING_DATA";
export const GET_ACTIVITY_CONFIGURATION_SETTING_MAPPING =
  "GET_ACTIVITY_CONFIGURATION_SETTING_MAPPING";
export const WORKFLOW_HEADER_NAME = "WORKFLOW_HEADER_NAME";
export const SET_WORKFLOW = "SET_WORKFLOW";

// Activity Performance
export const GET_ALL_ACTIVITIES = "GET_ALL_ACTIVITIES";
export const GET_ALL_TODO_PERFORMANCE_DATA = "GET_ALL_TODO_PERFORMANCE_DATA";
export const GET_ALL_ASSET = "GET_ALL_ASSET";
export const GET_ALL_ASSET_ENTRIES = "GET_ALL_ASSET_ENTRIES";
export const GET_ALL_ASSET_DATA = "GET_ALL_ASSET_DATA";
export const GET_ALL_TODO_CUSTOM_COMPONENTS = "GET_ALL_TODO_CUSTOM_COMPONENTS";
export const GET_ALL_TODO_DATA = "GET_ALL_TODO_DATA";
export const GET_ALL_TODO_PERFORMANCE = "GET_ALL_TODO_PERFORMANCE";
export const GET_ALL_BOOKING_DETAILS = "GET_ALL_BOOKING_DETAILS";
export const GET_ALL_FILE_NAME = "GET_ALL_FILE_NAME";
export const GET_ALL_DOCUMENT = "GET_ALL_DOCUMENT";
export const GET_ALL_TODO_PERFORMANCE_GROUP = "GET_ALL_TODO_PERFORMANCE_GROUP";
export const SET_ASSET_TYPES = "SET_ASSET_TYPES";
export const RESET_TODO_PERFORMANCE = "RESET_TODO_PERFORMANCE";
export const RESET_ALL_ACTIVITIES = "RESET_ALL_ACTIVITIES";
export const GET_BOOKING_GROUPS = "GET_BOOKING_GROUPS";
export const RESET_BOOKING_GROUPS = "RESET_BOOKING_GROUPS";
export const RESET_TODO_CHAT = "RESET_TODO_CHAT";
export const TODO_CHAT = "TODO_CHAT";
export const GET_ALL_BOOKING_FILE_UPLOAD = "GET_ALL_BOOKING_FILE_UPLOAD";
export const SET_USER_LIST = "SET_USER_LIST";
export const SET_THREAD_COUNTER = "SET_THREAD_COUNTER";
export const PERFORMANCE_LOADER = "PERFORMANCE_LOADER";

export const SET_JOB_ID = "SET_JOB_ID";
export const SET_UNITS = "SET_UNITS";
export const SET_CUSTOM_FIELDS = "SET_CUSTOM_FIELDS";
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const SET_ACTIVITY_DROPDOWN_PARAMS = "SET_ACTIVITY_DROPDOWN_PARAMS";
export const SET_CUSTOM_COMPONENTS = "SET_CUSTOM_COMPONENTS";
export const SET_ACTIVITY_PERFORMANCE_TABLE_INFO =
  "SET_ACTIVITY_PERFORMANCE_TABLE_INFO";
export const SET_ACTIVITY_PERFORMANCE_FILE_LIST =
  "SET_ACTIVITY_PERFORMANCE_FILE_LIST";
export const SET_ACTIVITY = "SET_ACTIVITY";
export const SET_JOBS = "SET_JOBS";
export const GET_HEADERNAME_BY_COMPANY_ID = "GET_HEADERNAME_BY_COMPANY_ID";
export const STORE_CONFIGURATION_ID = "STORE_CONFIGURATION_ID";
export const REMOVE_CONFIGURATION_ID = "REMOVE_CONFIGURATION_ID";
export const GET_ALL_ACTIVITY_WITH_CUSTOM_FIELD =
  "GET_ALL_ACTIVITY_WITH_CUSTOM_FIELD";
export const SET_PERFORMANCE_HEADER_DATA = "SET_PERFORMANCE_HEADER_DATA";
export const RESET_PERFORMANCE_STATE = "RESET_PERFORMANCE_STATE";
export const RESET_ACTIVITY_PERFORMANCE_TABLE_INFO =
  "RESET_ACTIVITY_PERFORMANCE_TABLE_INFO";
export const DOWNLOAD_TODO_PERFORMANCE_DOCUMENTS = "DOWNLOAD_TODO_PERFORMANCE_DOCUMENTS";
export const DOWNLOAD_BOOKING_DOCUMENTS = "DOWNLOAD_BOOKING_DOCUMENTS" 
export const GET_SCAC_DATA = "GET_SCAC_DATA"
export const GET_BOOKING_REFERENCE_DATA = "GET_BOOKING_REFERENCE_DATA" 
export const GET_PERFORMANCE_INVENTORY_DATA = "GET_PERFORMANCE_INVENTORY_DATA"
export const SET_ASSET_DATA_FOR_TRACKING = "SET_ASSET_DATA_FOR_TRACKING"
// Onboarding screen
export const GET_MASTER_CATEGORY = "GET_MASTER_CATEGORY";
export const GET_MASTER_ACTIVITY = "GET_MASTER_ACTIVITY";
export const SET_ONBOARD_SLIDE_2_DATA = "SET_ONBOARD_SLIDE_2_DATA";
export const SET_ONBOARD_SLIDE_3_DATA = "SET_ONBOARD_SLIDE_3_DATA";
export const ADD_TEAM_ON_ONBOARDING = "ADD_TEAM_ON_ONBOARDING";
export const GET_TIMEZONE_FOR_ONBOARDING_SCREEN =
  "GET_TIMEZONE_FOR_ONBOARDING_SCREEN";
export const GET_ASSET_TYPE_FOR_ONBOARDING_SCREEN =
  "GET_ASSET_TYPE_FOR_ONBOARDING_SCREEN";

// Overview page
export const GET_OVERVIEW_TABLE_DATA = "GET_OVERVIEW_TABLE_DATA";
export const SET_SEARCH_DATA = "SET_SEARCH_DATA";
export const SET_SELECTED_DATA = "SET_SELECTED_DATA";
export const SET_LOCK_TO_DO_FILTER = "SET_LOCK_TO_DO_FILTER";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
export const GET_OVERVIEW_SUMMARY_COUNT = "GET_OVERVIEW_SUMMARY_COUNT";
export const SET_USER_TYPE_FILTER = "SET_USER_TYPE_FILTER";
export const SET_USER_FILTER = "SET_USER_FILTER"
export const SET_TODO_FILTER = "SET_TODO_FILTER"
export const GROUPED_BY_FILTER = "GROUPED_BY_FILTER"
export const SET_DATE_RANGE = "SET_DATE_RANGE"
export const SET_NOTIFICATION_DATA_FOR_OVERVIEW_SCREEN = "SET_NOTIFICATION_DATA_FOR_OVERVIEW_SCREEN"

//Manage Template
export const ADD_BOOKING_TEMPLATE_NAME = "ADD_BOOKING_TEMPLATE_NAME";
export const GET_ALL_BOOKING_TEMPLATE_BY_COMPANY_ID =
  "GET_ALL_BOOKING_TEMPLATE_BY_COMPANY_ID";
export const GET_ALL_BOOKING_NAME = "GET_ALL_BOOKING_NAME";
export const SET_TEMPLATE_HEADER_NAME = "SET_HEADER_NAME";
export const SET_TEMPLATE_PREVIEW_DATA = "SET_TEMPLATE_PREVIEN_DATA";
export const SET_TEMPLATE_GRID_LAYOUT_DATA = "SET_TEMPLATE_GRID_LAYOUT_DATA";
export const CLEAR_COMPONENT_GRID_LAYOUT_DATA =
  "CLEAR_COMPONENT_GRID_LAYOUT_DATA";
export const CLEAR_COMPONENT_PREVIEW_DATA = "CLEAR_COMPONENT_PREVIEW_DATA";
export const GET_BOOKING_TEMPLATE_BY_BOOKING_TEMPLATE_ID =
  "GET_BOOKING_TEMPLATE_BY_BOOKING_TEMPLATE_ID";

//Bookings
export const GET_ALL_BOOKING_BY_COMPANY_ID = "GET_ALL_BOOKING_BY_COMPANY_ID";
export const GET_ALL_BOOKINGS_VALUE = "GET_ALL_BOOKINGS_VALUE";
export const CHECK_PLAN = "CHECK_PLAN";
export const GET_BOOKING_FIELD_LIST = "GET_BOOKING_FIELD_LIST";

// Store Temporary Window Data
export const SAVE_TEMPORARY_DATA = "SAVE_TEMPORARY_DATA";
export const RESET_SAVE_TEMPORARY_DATA = "RESET_SAVE_TEMPORARY_DATA";

//Billing Details
export const GET_ALL_STORAGE_BY_COMPANY_ID = "GET_ALL_STORAGE_BY_COMPANY_ID";
export const GET_ALL_MODULE_INFO_BY_COMPANY_ID =
  "GET_ALL_MODULE_INFO_BY_COMPANY_ID";

// Email Notification
export const GET_NOTIFICATION_SETTINGS = "GET_NOTIFICATION_SETTINGS";
export const ADD_AND_UPDATE_NOTIFICATION_SETTINGS =
  "ADD_AND_UPDATE_NOTIFICATION_SETTINGS";

export const RESET_REDUX_STATE = "RESET_REDUX_STATE";

// Manage Component
export const GET_COMPONENT_LIST_BY_COMPANY_ID =
  "GET_COMPONENT_LIST_BY_COMPANY_ID";
export const DELETE_COMPONENT_BY_ID = "DELETE_COMPONENT_BY_ID";
export const GET_MASTER_COMPONENT_LIST = "GET_MASTER_COMPONENT_LIST";
export const SET_STAKEHOLDER_COMPONENT = "SET_STAKEHOLDER_COMPONENT";

// Manage Client Secret
export const GET_CLIENT_SECRET_BY_COMPANY_ID =
  "GET_CLIENT_SECRET_BY_COMPANY_ID";
export const ADD_CLIENT_SECRET = "ADD_CLIENT_SECRET";
export const DELETE_CLIENT_SECRET_BY_ID = "DELETE_CLIENT_SECRET_BY_ID";

// Sidebar collapse
export const CHECK_IS_SIDEBAR_COLLAPSE = "CHECK_IS_SIDEBAR_COLLAPSE";

//Collaborator & Customer
export const GET_COLLABORATOR_OR_CUSTOMER = "GET_COLLABORATOR_OR_CUSTOMER";
export const GET_COLLABORATOR_DETAILS = "GET_COLLABORATOR_DETAILS";
export const GET_CUSTOMER_DETAILS = "GET_CUSTOMER_DETAILS";

// Customized Table
export const GET_CUSTIMIZED_TABLE_DATA = "GET_CUSTIMIZED_TABLE_DATA";
export const GET_CUSTIMIZED_TABLE_DATA_FOR_OVERVIEW = "GET_CUSTIMIZED_TABLE_DATA_FOR_OVERVIEW"

// Analytics Dashboard
export const ADD_TO_MY_DASHBORAD = "ADD_TO_MY_DASHBORAD"
export const GET_WIDGETS_FOR_OVERALL_TAB = "GET_WIDGETS_FOR_OVERALL_TAB"
export const GET_WIDGETS_FOR_MY_DASHBOARD_TAB = "GET_WIDGETS_FOR_MY_DASHBOARD_TAB"
export const GET_WIDGETS_FOR_COLLABORATOR_PERFORMANCE_TAB = "GET_WIDGETS_FOR_COLLABORATOR_PERFORMANCE_TAB"
export const GET_WIDGETS_FOR_CUSTOMER_ANALYSIS_TAB = "GET_WIDGETS_FOR_CUSTOMER_ANALYSIS_TAB"
export const GET_WIDGETS_FOR_USER_PERFORMANCE_TAB = "GET_WIDGETS_FOR_USER_PERFORMANCE_TAB"

// My Overview Tab
export const GET_OVERVIEW_CARD_DETAILS = "GET_OVERVIEW_CARD_DETAILS"
export const GET_SINGLE_CARD_DETAILS = "GET_SINGLE_CARD_DETAILS"

// SKU Master
export const GET_SKU_DATA = "GET_SKU_DATA"
export const GET_MASTER_UOM_DATA = "GET_MASTER_UOM_DATA"
export const GET_ALL_SKU_DATA = "GET_ALL_SKU_DATA"
export const SKU_INVENTORY_BY_SKU_ID = "SKU_INVENTORY_BY_SKU_ID"
export const CLEAR_SKU_INVENTORY_BY_SKU_ID = "CLEAR_SKU_INVENTORY_BY_SKU_ID"

// Product Master
export const GET_PRODUCT_DATA = "GET_PRODUCT_DATA"
export const GET_PRODUCT_DATA_BY_ID = "GET_PRODUCT_DATA_BY_ID"
export const RESET_SINGLE_PRODUCT_DATA = "RESET_SINGLE_PRODUCT_DATA"
export const GET_ALL_PRODUCT_DATA = "GET_ALL_PRODUCT_DATA"
export const PRODUCT_INVENTORY_BY_PRODUCT_ID = "PRODUCT_INVENTORY_BY_PRODUCT_ID"
export const CLEAR_PRODUCT_INVENTORY_BY_PRODUCT_ID = "CLEAR_PRODUCT_INVENTORY_BY_PRODUCT_ID"

// Purchase Order
export const GET_PURCHASE_ORDER = "GET_PURCHASE_ORDER"
export const GET_PURCHASE_REQUIREMENT_DATA = "GET_PURCHASE_REQUIREMENT_DATA"

// Production Order
export const GET_PRODUCTION_ORDER = "GET_PRODUCTION_ORDER"
export const GET_PRODUCTION_REQUIREMENT_DATA = "GET_PRODUCTION_REQUIREMENT_DATA"
export const SET_PRODUCTION_ORDER_NO = "SET_SALES_ORDER_NO"

// Sales Order
export const GET_SALES_ORDER = "GET_SALES_ORDER"
export const SET_SALES_ORDER_NO = "SET_SALES_ORDER_NO"

//Correction Order
export const GET_CORRECTION_ORDER = "GET_CORRECTION_ORDER"

// Inventory
export const GET_SKU_INVENTORY_DATA = "GET_SKU_INVENTORY_DATA"
export const GET_PRODUCT_INVENTORY_DATA = "GET_PRODUCT_INVENTORY_DATA"
export const GET_INVENTORY_ALL_COUNT = "GET_INVENTORY_ALL_COUNT"
export const GET_INVENTORY_SKU_TABLE_LAYOUT = "GET_INVENTORY_TABLE_LAYOUT"
export const GET_INVENTORY_PRODUCT_TABLE_LAYOUT = "GET_INVENTORY_PRODUCT_TABLE_LAYOUT"
export const CLEAR_INVENTORY_TABLE_LAYOUT = "CLEAR_INVENTORY_TABLE_LAYOUT"

// Previous Path
export const SET_PREVIOUS_PATH = "SET_PREVIOUS_PATH"